import { InjectionToken } from '@angular/core';
import { UsersConfig } from '@digilize/shared/definitions/src/lib/interfaces/UsersConfig';

export const USERS_CONFIG_TOKEN = new InjectionToken<UsersConfig>('USERS_CONFIG');
